// extracted by mini-css-extract-plugin
module.exports = {"paymentSection":"ExpressPaymentPage_paymentSection__27E3S","cardSummary":"ExpressPaymentPage_cardSummary__32iLQ","summary":"ExpressPaymentPage_summary__Hqr3l"};